<template>
    <div>
        <v-snackbar
            v-for="(notification, index) in getNotifications"
            :key="index + notification.message"
            :model-value="true"
            :timeout="notification.popupTimeout || popupTimeout"
            :color="notification.severity || 'success'"
            bottom
        >
            {{ notification.message }}
        </v-snackbar>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import eventMixin from '@/js/mixins/events';

export default {
    mixins: [eventMixin],
    props: {
        popupTimeout: Number,
    },
    data() {
        return {
            model: true,
        };
    },

    events: {
        onSuccessfulSubmit(options) {
            const entityName = this.toSentenceCase(this.$t(`entities.${options.entityName}`));
            this.addNotification({
                message: this.$t('notifications.saveSuccess', { entityName }),
            });
        },
    },

    computed: {
        ...mapGetters('notifications', ['getNotifications']),
    },

    methods: {
        ...mapActions('notifications', ['addNotification']),
    },
};
</script>
